import React, { useEffect } from 'react'

function CircularProgressBar({ DashArray = [], subTitle= '', styleCss, show }) {
  let progressCount = DashArray[0].toFixed(0)

  let percentage = (DashArray[0]/ DashArray[1])*100
  DashArray =  [percentage.toFixed(0),100] 
  useEffect(()=> {
    progressCount
  }, [])
  return (
    <div style={styleCss} >
      <div className="flex flex-center" >
          <div className="circular-progress text-center">
            <svg viewBox="0 0 36 36" className='circular-chart green' >
              <path className="circle-bg" 
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={DashArray} 
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            {progressCount && show && <text x={progressCount > 9 ? ( progressCount < 20 ? "12" : (progressCount < 100 ? "10" : '8') ):  "14"} y="20.35" className='progress-count'>{progressCount}</text>}
            {subTitle && <text x="18" y="26.35" className="percentage-sub-text">{subTitle}</text>}                
          </svg>
          </div>
       </div>   
     </div>
  )
}

export default CircularProgressBar